import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-informes-lumat',
    imports: [],
    templateUrl: './informes.component.html',
    styleUrl: './informes.component.scss'
})
export class InformesComponent implements OnInit {
    urlSafe!: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('https://informes.arco.com.py/');
    }
}
